import type { MovieFilters } from "@/utils/content";

interface MovieFilterPanelProps {
  options: {
    types: string[];
    regions: string[];
    years: string[];
    ratings: string[];
  };
  value: MovieFilters;
  onChange: (key: keyof MovieFilters, val: string) => void;
  onReset: () => void;
}

const groups: { key: keyof MovieFilters; label: string; optionKey: keyof MovieFilterPanelProps["options"] }[] = [
  { key: "type", label: "类型", optionKey: "types" },
  { key: "region", label: "地区", optionKey: "regions" },
  { key: "year", label: "年代", optionKey: "years" },
  { key: "rating", label: "评分", optionKey: "ratings" }
];

export default function MovieFilterPanel({
  options,
  value,
  onChange,
  onReset
}: MovieFilterPanelProps) {
  return (
    <div className="space-y-6">
      {groups.map((group) => (
        <div key={group.key}>
          <h4 className="mb-3 font-heading text-sm font-600 text-foreground-200">
            {group.label}
          </h4>
          <div className="flex flex-wrap gap-2">
            {options[group.optionKey].map((option) => {
              const active = (value[group.key] || "全部") === option;
              return (
                <button
                  key={option}
                  type="button"
                  onClick={() => onChange(group.key, option)}
                  className={`cursor-pointer whitespace-nowrap rounded-full border px-3 py-1 text-xs font-500 transition-colors ${
                    active
                      ? "border-accent-500 bg-accent-500 text-background-950"
                      : "border-background-700 bg-background-900 text-foreground-300 hover:border-secondary-500 hover:text-secondary-300"
                  }`}
                >
                  {option}
                </button>
              );
            })}
          </div>
        </div>
      ))}
      <button
        type="button"
        onClick={onReset}
        className="flex w-full cursor-pointer items-center justify-center gap-2 rounded-md border border-background-700 py-2 text-sm text-foreground-300 transition-colors hover:border-accent-500 hover:text-accent-400"
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-refresh-line" aria-hidden="true" />
        </span>
        重置筛选条件
      </button>
    </div>
  );
}